import type { Space } from '@cocoonspace/sdk-js/types/space'
import { track as vercelTrack } from '@vercel/analytics'
import { useTranslation } from 'next-i18next'
import {
	Breadcrumb,
	BreadcrumbEllipsis,
	BreadcrumbItem,
	BreadcrumbLink,
	BreadcrumbList,
	BreadcrumbPage,
	BreadcrumbSeparator,
	HomeBreadcrumbItem,
} from '~/components/ui/breadcrumb'
import { useTracking } from '~/providers/tracking-provider'

export const SpaceDetailsBreadcrumb = ({
	space,
	isDesk,
}: {
	space?: Space
	isDesk?: boolean
}) => {
	const { t } = useTranslation()
	const { track } = useTracking()

	return (
		<Breadcrumb>
			<BreadcrumbList className='min-w-0 flex-nowrap'>
				<HomeBreadcrumbItem
					onClick={() => {
						track.click('breadcrumb-link', { route: '/' })
						vercelTrack('click-breadcrumb-link', { target: '/' })
					}}
				/>

				<BreadcrumbSeparator />

				<BreadcrumbItem>
					<BreadcrumbLink
						href={isDesk ? `/desks/${space?.zone}` : `/${space?.zone}`}
						className='capitalize'
						onClick={() => {
							track.click('breadcrumb-link', { route: `/${space?.zone}` })
							vercelTrack('click-breadcrumb-link', {
								target: `/${space?.zone}`,
							})
						}}
					>
						{space?.zone}
					</BreadcrumbLink>
				</BreadcrumbItem>

				{!isDesk && (
					<>
						<BreadcrumbSeparator />

						<BreadcrumbItem>
							<BreadcrumbLink
								href={`/venues/${space?.venue_slug}`}
								className='capitalize max-md:hidden'
								onClick={() => {
									track.click('breadcrumb-link', {
										route: `/venues/${space?.venue_slug}`,
									})
									vercelTrack('click-breadcrumb-link', {
										target: `/venues/${space?.venue_slug}`,
									})
								}}
							>
								{space?.venue_name}
							</BreadcrumbLink>

							<BreadcrumbEllipsis className='md:hidden' />
						</BreadcrumbItem>
					</>
				)}

				<BreadcrumbSeparator />

				<BreadcrumbItem className='min-w-0 truncate'>
					<BreadcrumbPage className='truncate'>{space?.title}</BreadcrumbPage>
				</BreadcrumbItem>
			</BreadcrumbList>
		</Breadcrumb>
	)
}
